import React, { useEffect, useState } from "react";
import { SET_LOADING } from "../../redux/user";
import { useDispatch } from "react-redux";
import { api_paths } from "../../config/api.paths";
import { toastErrorMessage } from "../../utils/utils";
import API from "../../config/axios";
import { Col, Container, Row } from "react-bootstrap";

const PrivacyPolicy = () => {
  const [page, setPage] = useState();
  const dispatch = useDispatch();

  const getPageDetails = async (identifier) => {
    dispatch(SET_LOADING(true));
    try {
      const response = await API.get(`${api_paths.GET_CMS_PAGE}${identifier}`);
      if (response?.data?.payload?.result) {
        setPage(response?.data?.payload?.result);
      }
    } catch (error) {
      console.log(error);
      toastErrorMessage(error?.response?.data?.message);
    }
    dispatch(SET_LOADING(false));
  };

  useEffect(() => {
    getPageDetails("PRIVACY_POLICY"); // privacy_policy term_condition about_us
    //eslint-disable-next-line
  }, []);

  return (
    <Container>
      <Row className="text-center pt-4 pb-2">
        <Col lg={12}>
          <h1 className="mb-3 h1 text-main">Privacy Policy</h1>
          <p className="mb-0">
            Welcome to{" "}
            <a
              href="https://www.gujaratisamajtampabay.com/"
              target="blank"
              className="text-decoration-none fw-bold"
            >
              www.gujaratisamajtampabay.com
            </a>
            , a site owned by the Gujarati Samaj of Tampa Bay Inc. (GSTB)
          </p>
        </Col>
      </Row>
      <hr />
      <Row className="mt-4">
        <Col lg={12} className="px-3">
          <div
            className="cms_pages"
            dangerouslySetInnerHTML={{ __html: page?.content }}
          ></div>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;
